import * as React from 'react'
import { Button, Divider } from '@mui/material'

import { KaingaOraLogoWithText, ImageMobile, HnzBackground } from '../../../utils/imagesProvider'

import '../../platform/styles/NewFeaturePage.scss'

interface Props {
	onNext: () => void
	onClose: () => void
}

export default class HnzNewFeaturePageSix extends React.PureComponent<Props> {

	render() {
		const { onNext, onClose } = this.props

		return (
			<div className="page">
				<div className="page__heading">
					<img src={KaingaOraLogoWithText} alt="Kāinga Ora Logo" className="page__logo--heading" />

					<Button
						className="page__button--skip"
						onClick={onClose}
					>
						SKIP
					</Button>
				</div>

				<div className="page__content">
					<h1 className="page__text--heading page__text--heading-themed">
						DOWNLOAD TODAY
					</h1>

					<h2 className="page__text--subheading page__text--subheading-emphasized">
						ORDER ON THE GO WITH PWGO
					</h2>

					<img src={ImageMobile} alt="pwGO Mobile" className="page__image--pwgo-mobile" />

					<Divider className="page__divider" />

					<p className="page__text">
						Tailored to our Kāinga Ora tradies.<br />
						Download pwGO from the App Store or Google Play.
					</p>
				</div>

				<div className="page__footer">
					<Button
						variant="outlined"
						className="button--fixed-width"
						onClick={onNext}
					>
						NEXT
					</Button>
				</div>

				<img src={HnzBackground} alt="Kāinga Ora" className="page__background page__background--hnz" />
			</div>
		)
	}
}